<template>
    <div>
        <headerNav :title="title" />
        <div class="fmain">
            <van-list
                    v-model="queryparams.loaded"
                    :finished="queryparams.loadingType=='nomore'?true:false"
                    :finished-text="queryparams.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                    @load="loaddata">
                <div class="fcontent" @click="goto('/mproductdetail',item)"  v-for="(item,index) in vlist" :key="index">
                    <div class="ftit">
                        <span class="ftit-big">{{item.title}}</span>
                        <span class="ftit-small">{{item.fTitle}}</span>
                    </div>
                    <div class="fimg" v-if="item.listPicPath">
                        <div class="fimg-dw">
                            <img :src="$baseurl+item.listPicPath"/>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>
<script>
import Util from "../../config/Util";
export default {
    data(){
        return {
            queryparams:{
                loaded:false,
                loadingType: 'more',
                name:"",
                sku:"",
                ProductType:undefined,
                productSku: "",
                sorting: " sorter desc,id desc",
                maxResultCount: 6,
                skipCount: 0,
                filterindex:0,
                categoryId:0,
                isIntegral:false
            },
            refreshing:false,
            vlist:
            [
               
            ],
            title:'品牌馆'
        }
    },
    created(){
         this.loaddata('refresh');
    },
    methods:{
        goto(url,item)
        {
            this.$router.push({path:url,query:{id:item.id}});
        },
        onRefresh()
        {
            this.loaddata('refresh');
        },
        loaddata(source)
        {
            if (this.queryparams.loadingType === 'loading' || this.queryparams.loadingType === 'nomore') {
                //防止重复加载
                if(source != 'refresh')
                {
                    return;
                } 
            }
            if (source == 'refresh') {
                this.vlist = [];
                this.queryparams.skipCount = 0;
            }
            this.queryparams.loadingType = 'loading';
            this.ajax.post('/api/services/app/PhoneCom/QueryTopList', this.queryparams).then(x => {
                this.queryparams.skipCount += this.queryparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.vlist = this.vlist.concat(x.result.items);
                console.log(this.vlist);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.queryparams.loadingType = totalcount > (this.queryparams.skipCount) ? 'more' :'nomore';
            }).finally(()=>
            {
                    this.queryparams.loaded=false;
                    this.refreshing=false;
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.fmain{
    padding: 10px 15px;
    background-color: #fff;
    font-size: 12px;
}
.fcontent{
    margin-bottom: 20px;
}
.fcontent:last-child{
    margin-bottom:0;
}
.ftit-big{
    font-size: 14px;
    margin-right: 5px;
    font-weight: bold;
}
.ftit-small{
    color:#a6a6a6;
}
.fimg-dw{
   margin-top:10px;
   position:relative;
}
.fimg-dw img{
    width: 100%;
    height: auto;
}

.fimg-content{
    position: absolute;
    left:20px;
    top:50%;
    transform: translate(0,-50%);
}
.fimg-content{
    width: 120px;
}
.fimg-content-wz{
     color:#a6a6a6;
}

</style>